import React, { Fragment, useEffect } from "react";
import { dateFilterParams, dateValueGetter, formatOnlyDate } from "../utils";
import { fetchClearDetailTask, fetchTaskList } from "../actions/task";
import { statusRender, statusSectorRender } from "../utils/cellRenderTable";

import AggridTable from "../components/Admin/Reusable/AggridTable";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { fetchDeleteTask } from "../actions/task";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const TaskList = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  //breadcrumb
  const translateModule = "tasks";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const { taskList } = useSelector((state) => state.taskReducer);

  useEffect(() => {
    dispatch(fetchTaskList());
    dispatch(fetchClearDetailTask());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id) return null;
    return (
      <ButtonColumn
        editLink={`/task-edit/` + params.data.id}
        editLinkDetail={`/task-detail/` + params.data.id}
        textToltipDetail={t("taskList.taskDetail")}
        deleteItemId={params.data.id}
        deleteItemTitle={`${params.data.name}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    dispatch(fetchDeleteTask(pageId));
  };

  //settings za tabelu
  const columnDefs = [
    {
      headerName: t("promotionList.countryName"),
      field: "countryName",
      filter: "agSetColumnFilter",
      width: 150,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("taskList.name"),
      field: "name",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("awardForm.level"),
      field: "levelName",
      filter: "agTextColumnFilter",
      minWidth: 100,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("taskList.experience"),
      field: "experience",
      filter: "agTextColumnFilter",
      minWidth: 100,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("taskList.status"),
      field: "status",
      filter: "agSetColumnFilter",
      cellRenderer: statusRender,
      valueGetter: (params) => {
        if (!params.data || !params.data.status) return null;
        switch (params.data.status) {
          case "INACTIVE":
            return t("taskList.inactive");
          case "ACTIVE":
            return t("taskList.active");
          default:
            return "";
        }
      },
      width: 150,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("taskList.startDate"),
      field: "startDate",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("customerList.sectorName"),
      field: "sector",
      filter: "agSetColumnFilter",
      cellRenderer: statusSectorRender,
      valueGetter: (params) => {
        if (!params.data || !params.data.sector) return null;
        switch (params.data.sector) {
          case "DEVICE_FOR_HOUSE":
            return "Aparati za kuću";
          case "TV_AUDIO":
            return "TV/Audio";
          case "DEVICE_FOR_HOUSE_AND_TV_AUDIO":
            return "Aparati za kuću i TV/Audio";
          default:
            return "";
        }
      },
    },
    {
      headerName: t("taskList.endDate"),
      field: "endDate",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 110,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={translateModule}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        rowData={taskList}
        columnDefs={columnDefs}
        buttonLink={`/task-add`}
        buttonText={t("taskList.addTask")}
        gridStateKey={"task-list"}
      />
    </Fragment>
  );
};

export default TaskList;
